import React, { useMemo, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import Table from "../../components/utils/Table";
import CardLayout from "../../components/utils/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import reportActions from "../../redux/reports/actions";
import genericActions from "../../redux/generic/actions";
import { downloadExcelSampleFile } from "../../helpers/commonFunction";
import moment from "moment";

const { getACode } = genericActions;
const { getTransactionLedgerReports, resetMessage } = reportActions;
const dateFormat = process.env.REACT_APP_DATE_TIME_FORMAT;


const LedgerReport = () => {
  const dispatch = useDispatch();
  const { aCodeList } = useSelector(state => state.generic);
  const [searchItem, setSearchItem] = useState("");
  const today = new Date();
  const beforeTwoDays = new Date();
  beforeTwoDays.setDate(beforeTwoDays.getDate() - 2);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const { transactionLedgerReport, transactionLedgerReportLoading, } = useSelector((state) => state.reports)
  const { defaultCurrency } = useSelector((state) => state.auth);

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      distributorID: "0",
      fromDate: formatDate(beforeTwoDays),
      toDate: formatDate(today),
    },
  });

  useEffect(() => {
    dispatch(getACode());
    dispatch(getTransactionLedgerReports({
      fromDate: formatDate(beforeTwoDays),
      toDate: formatDate(today),
    }));
  }, [dispatch]);


  const columns = [
    { displayName: "Transaction Type", key: "transactionType" },
    { displayName: "Serial Number", key: "serialNumber" },
    { displayName: "MSISDN", key: "msisdn" },
    { displayName: "Plan Name", key: "planName" },
    // { displayName: "Plan Amount", key: "planAmount" },
    { displayName: "Charge Amount", key: "chargeAmount" },
    // { displayName: "Previous Balance", key: "PreviousBalance" },
    { displayName: "Current Balance", key: "CurrentBalance" },
    { displayName: "Validity Days", key: "validity" },
    { displayName: "Transaction Date", key: "TransactionDate" },
    { displayName: "Transaction ID", key: "TransactionID" },

    { displayName: "Status", key: "status" },

  ];

  const filteredItems = useMemo(() => {
    return Array.isArray(transactionLedgerReport) && transactionLedgerReport.length > 0
      ? transactionLedgerReport.filter(item => {
        if (!searchItem) return true;
        return Object.values(item).some(val => typeof val === "string" && val.toLowerCase().includes(searchItem.toLowerCase()));
      })
      : [];
  }, [transactionLedgerReport, searchItem]);

  const rowData = useMemo(() => {
    return (filteredItems || []).map((item) => ({
      transactionType: item["TransactionType"],
      serialNumber: item["SerialNumber"],
      msisdn: item["MobileNumber"],
      planName: item["PlanName"],
      planAmount: defaultCurrency + '' + item["PlanAmount"],
      chargeAmount: defaultCurrency + '' + item["ChargeAmount"],
      validity: item["ValidityDays"],
      TransactionDate: moment(item?.TransactionDate).format(dateFormat),
      TransactionID: item["TransactionID"],
      PreviousBalance: defaultCurrency + '' + item["PreviousBalance"],
      CurrentBalance: defaultCurrency + '' + item["CurrentBalance"],
      status: item["Status"] === "Success" ? (<span className="badge bg-success">{item["Status"]}</span>) : (<span className="badge bg-danger">{item["Status"]}</span>),
    }));
  }, [filteredItems]);


  const onSubmit = (data) => {
    dispatch(getTransactionLedgerReports({
      ...data,
      distributorID: Number(data.distributorID || 0),
    }))
  };

  const handleReset = () => {
    reset({
      distributorID: "0",
      fromDate: formatDate(beforeTwoDays),
      toDate: formatDate(today),
    });

    setSearchItem("");
    dispatch(resetMessage());
    dispatch(resetMessage());
  };


  const handleExportExcel = () => {
    const data = filteredItems.map(item => ({
      "Transaction Type": item["TransactionType"],
      "Serial Number": item?.SerialNumber,
      "MSISDN": item["MobileNumber"],
      "Plan Name": item?.PlanName,
      // "Plan Amount": defaultCurrency + '' + item["PlanAmount"],
      "Charge Amount": defaultCurrency + '' + item["ChargeAmount"],
      // "Previous Balance": defaultCurrency + '' + item?.PreviousBalance,
      "Current Balance": defaultCurrency + '' + item?.CurrentBalance,
      "Validity Days": item["ValidityDays"],
      "Transaction Date": moment(item?.TransactionDate).format(dateFormat),
      "Transaction ID": item?.TransactionID,

      "Status": item["Status"],
    }))
    downloadExcelSampleFile(data, "Transaction_Ledger_report.xlsx");
  };

  return (
    <>
      {/* <Loader/>  */}
      <CardLayout
        title="Transaction Ledger Report"
        icon="ri-file-chart-line "
        rightContent={
          <div className="d-flex flex-wrap align-items-center gap-1">
            <input
              type="search"
              style={{ width: "300px", }}
              onChange={(e) => setSearchItem(e.target.value)}
              className="form-control form-control-sm"
              placeholder="Search..."
              value={searchItem}
            />
            <Button
              title="Excel"
              buttonType="button"
              variant="secondary"
              onClick={handleExportExcel}
              icon={<i className="ri-download-cloud-line me-2" />}
            />
          </div>
        }
      >
        <div>
          {/* Body */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row" >
              {/* ACode */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">ACode</label>
                <select
                  className="form-select"
                  {...register("distributorID")} >
                  <option value="0">All</option>
                  {aCodeList?.map((item) => (
                    <option
                      key={item.Id}
                      value={item.Id} >
                      {item.ACode}
                    </option>
                  ))}
                </select>
              </div>

              {/* From Date */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  {...register("fromDate")}
                />
              </div>

              {/* To Date */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  {...register("toDate")}
                />
              </div>


              <div className="col-lg-3 col-md-6 d-flex align-items-end gap-3" style={{ height: '70px' }}>
                {/* Buttons */}
                <Button
                  title="Get Report"
                  buttonType="submit"
                  variant="primary"
                  disable={transactionLedgerReportLoading}
                  loading={transactionLedgerReportLoading}
                  icon={<i className="ri-search-line me-2"></i>}
                  style={transactionLedgerReportLoading ? { width: '46.5%', padding: '10px 2px' } : {}}
                />

                <Button
                  title="Reset"
                  buttonType="button"
                  variant="secondary"
                  onClick={handleReset}
                  icon={<i className="ri-refresh-line me-2"></i>}
                />
              </div>

            </div>
          </form>
        </div>
        {/* Table */}
        <div className="mt-2">
          <Table
            columns={columns}
            data={rowData}
            pagination
            loading={transactionLedgerReportLoading}
            // loading={true}
            tableHeight="335px"
          />
        </div>

      </CardLayout>
    </>
  );
};

export default LedgerReport;
